var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import Toggle from '@doordash/component-toggle';
import { StackChildren, Text, InlineChildren } from '@doordash/design-language';
import { InputContainer } from './budget_form_styles';
import { PermittedOrderContents, } from '../../types/budgets';
import { BudgetModalTestId } from '../../../testId';
export var OrderContentSelector = function (_a) {
    var values = _a.values, setFieldValue = _a.setFieldValue, teamAccountBudgetsConfigurationOptions = _a.teamAccountBudgetsConfigurationOptions;
    var allowedOrderContents = teamAccountBudgetsConfigurationOptions.allowedOrderContents;
    var permittedOrderContentsList = values.permittedOrderContentsList;
    if (!(allowedOrderContents.includes(PermittedOrderContents.WORK_ORDER_CONTENT_GROCERY) ||
        allowedOrderContents.includes(PermittedOrderContents.WORK_ORDER_CONTENT_ALCOHOL))) {
        return null;
    }
    var handlePermittedContentChange = function (orderContent, state) {
        var updatedPermittedContentsList = [];
        if (state) {
            updatedPermittedContentsList = __spread(permittedOrderContentsList, [
                orderContent,
            ]);
        }
        else {
            updatedPermittedContentsList = permittedOrderContentsList.filter(function (permittedOrderContent) { return permittedOrderContent !== orderContent; });
        }
        setFieldValue('permittedOrderContentsList', updatedPermittedContentsList);
    };
    return (React.createElement(InputContainer, { size: "large" },
        React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall },
            React.createElement(Text, { styles: Text.Styles.Label2Emphasis }, "Additional categories employees can order"),
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall, alignItems: InlineChildren.Alignment.FlexStart },
                allowedOrderContents.includes(PermittedOrderContents.WORK_ORDER_CONTENT_ALCOHOL) && (React.createElement(Toggle, { label: "Alcohol", type: Toggle.Types.Checkbox, "data-testid": BudgetModalTestId.AlcoholCheckBox, isSelected: values.permittedOrderContentsList.includes(PermittedOrderContents.WORK_ORDER_CONTENT_ALCOHOL), onChange: function (state) {
                        return handlePermittedContentChange(PermittedOrderContents.WORK_ORDER_CONTENT_ALCOHOL, state);
                    } })),
                allowedOrderContents.includes(PermittedOrderContents.WORK_ORDER_CONTENT_GROCERY) && (React.createElement(Toggle, { label: "Convenience & Grocery", type: Toggle.Types.Checkbox, "data-testid": BudgetModalTestId.ConvenienceGroceryCheckBox, isSelected: values.permittedOrderContentsList.includes(PermittedOrderContents.WORK_ORDER_CONTENT_GROCERY), onChange: function (state) {
                        return handlePermittedContentChange(PermittedOrderContents.WORK_ORDER_CONTENT_GROCERY, state);
                    } }))))));
};
export default OrderContentSelector;
